import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import AttendanceDetails from "./AttendanceDetails";
import AttendanceMonthly from "./AttendanceMonthly";

const NAVY = "#154c79";

export default function AttendanceDetailsTabs() {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        centered
        sx={{
          mb: 1,
          "& .MuiTabs-indicator": { backgroundColor: NAVY },
          "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 44 },
          "& .MuiTab-root.Mui-selected": { color: NAVY },
        }}
      >
        <Tab label="Daily" />
        <Tab label="Monthly" />
      </Tabs>

      {/* Only the visible tab is mounted, so Monthly loads its data when it is opened */}
      {tab === 0 && <AttendanceDetails />}
      {tab === 1 && <AttendanceMonthly />}
    </Box>
  );
}